/**
 * Contexte d'impersonation Super Admin → vue commerçant.
 * Ne pas confondre avec un objet User (prenom/nom).
 */
export function buildImpersonationContext(commercant) {
  if (!commercant?.id) return null;
  return {
    commercantId: commercant.id,
    commercantNom: commercant.nom || 'Boutique',
    role: 'COMMERCANT',
    permissions: Array.isArray(commercant.permissions) ? commercant.permissions : [],
  };
}

export function getImpersonatedCommercantId(ctx) {
  if (!ctx) return null;
  return ctx.commercantId || ctx.id || null;
}

export function getImpersonatedCommercantLabel(ctx) {
  if (!ctx) return '';
  if (ctx.commercantNom) return ctx.commercantNom;
  const personName = [ctx.prenom, ctx.nom].filter(Boolean).join(' ');
  return personName || 'Boutique';
}
